// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__AAd3B","form":"styles_form__3czTG"};